export function createEventPipelineOptions({
  selectedEventInfo,
  selectedEventId,
  resolveEventChatMode,
  unifiedMode,
  announcementChecks,
  getAnnouncementIconClass,
  linkifyText,
  parseTimetableRuntimePayload,
  isTimetableMemoMessage,
  resolveTimetableRuntimeVisibility,
  buildTimetableDetailUrl,
  messageFormats,
  messageFilePath,
  isTimetableRuntimeMessage,
  isSimpleAnnouncementMessage,
  isEventFinishedMessage,
  isEventMaterialSharedMessage,
  isEventImagesAddedMessage,
  isNoteMessage,
  isNoteDeleteMessage,
  buildNoteActionNode,
  buildMaterialActionNode,
  buildAlbumActionNode,
  buildEventFinishedActionNode,
  buildMessageImageUrl,
  onOpenImage,
  onDownload,
  buildAssetUrl,
  ellipsizeFileName,
  getFileIconClass,
  formatExpireDateLabel,
  onMentionClick,
  contentRendererOverrides = {},
}) {
  return {
    announcementRendererOptions: {
      selectedEventInfo,
      selectedEventId,
      resolveEventChatMode,
      unifiedMode,
      announcementChecks,
      getAnnouncementIconClass,
      linkifyText,
      parseTimetableRuntimePayload,
      isTimetableMemoMessage,
      resolveTimetableRuntimeVisibility,
      buildTimetableDetailUrl,
    },
    contentRendererOptions: {
      messageFormats,
      messageFilePath,
      selectedEventId,
      buildTimetableDetailUrl,
      isTimetableCreatedMessage: announcementChecks.isTimetableCreatedMessage,
      isTimetableUpdatedMessage: announcementChecks.isTimetableUpdatedMessage,
      isTimetableRuntimeMessage,
      isSimpleAnnouncementMessage,
      isEventFinishedMessage,
      isEventMaterialSharedMessage,
      isEventImagesAddedMessage,
      isNoteMessage,
      isNoteDeleteMessage,
      buildNoteActionNode,
      buildMaterialActionNode,
      buildAlbumActionNode,
      buildEventFinishedActionNode,
      buildMessageImageUrl,
      onOpenImage,
      onDownload,
      buildAssetUrl,
      ellipsizeFileName,
      getFileIconClass,
      formatExpireDateLabel,
      linkifyText,
      onMentionClick,
      ...contentRendererOverrides,
    },
  };
}
